import React from 'react'

const TitleIcon = ({ height = 25, top = 0, style = 0 }) => {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="25px" height="25px" viewBox="0 0 525.000000 525.000000"
      preserveAspectRatio="xMidYMid meet">
   
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#E61C34" stroke="none">
        <path d="M515 4903 c-55 -7 -138 -34 -195 -63 -133 -67 -248 -202 -292 -343
        l-23 -72 0 -1865 0 -1865 23 -72 c57 -183 209 -329 408 -390 56 -17 149 -18
        2124 -18 1977 0 2068 1 2125 18 194 60 335 192 403 378 l27 74 3 1842 c3 2024
        5 1920 -57 2048 -69 140 -194 249 -346 302 l-80 28 -2045 1 c-1125 1 -2058 -1
        -2075 -3z m4120 -336 c50 -23 110 -80 138 -132 17 -32 22 -62 25 -157 l4 -118
        -2242 0 -2242 0 4 118 c4 136 18 172 90 239 40 36 72 52 133 66 11 3 927 4
        2035 3 1917 -1 2017 -2 2055 -19z m163 -2284 l-3 -1558 -22 -40 c-28 -54 -100
        -119 -149 -136 -58 -21 -4070 -21 -4128 0 -49 17 -121 82 -149 136 l-22 40 -3
        1558 -2 1557 2240 0 2240 0 -2 -1557z"/>
        <path d="M735 3186 c-41 -18 -83 -69 -90 -109 -4 -18 -5 -118 -3 -224 3 -210
        5 -218 72 -267 39 -29 133 -29 172 0 60 44 69 67 72 185 l4 109 294 0 294 0 0
        -744 0 -743 -79 -5 c-93 -5 -136 -26 -169 -84 -42 -73 -19 -159 58 -211 32
        -23 38 -23 342 -23 342 0 357 2 400 63 34 47 36 132 6 177 -34 51 -98 80 -175
        80 l-63 0 0 745 0 745 289 0 289 0 4 -103 c4 -120 24 -164 91 -198 74 -38 153
        -14 205 61 21 32 22 42 22 240 0 198 -1 208 -22 240 -13 18 -36 43 -51 54 -28
        21 -32 21 -980 23 -776 2 -958 0 -982 -11z"/>
        <path d="M3295 3186 c-67 -29 -105 -106 -91 -181 9 -47 59 -102 104 -115 25
        -8 209 -10 554 -8 504 3 517 4 544 24 53 39 69 71 69 134 0 63 -16 95 -69 134
        -27 21 -40 21 -554 23 -423 2 -533 0 -557 -11z"/>
        <path d="M3307 2336 c-49 -18 -64 -32 -89 -80 -37 -73 -13 -153 62 -203 l33
        -23 527 0 527 0 33 23 c48 32 72 69 77 119 7 58 -23 118 -74 149 l-38 24 -510
        2 c-409 2 -517 0 -548 -11z"/>
        <path d="M3280 1468 c-48 -33 -72 -70 -77 -120 -7 -58 23 -118 74 -149 l38
        -24 525 0 525 0 38 24 c51 31 81 91 74 149 -5 50 -29 87 -77 120 l-33 22 -527
        0 -527 0 -33 -22z"/>
      </g>
    </svg>   
  )
}

export default TitleIcon
